import Logo from 'Components/Icons/Logo'
import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Context } from 'Context/Context'
import { isUserVerifiedApi, ADMIN, PROFESSIONAL, CLIENT } from 'Constants';
import { useContext } from 'react'
import MiniAvatar from 'Components/Icons/MiniAvatar'
import HomeMiniAvatar from 'Components/Icons/HomeMiniAvatar';
import NotificationIcon from 'Components/Icons/NotificationIcon';
import LogoMobile from 'Components/Icons/LogoMobile';
import { FiAlignJustify } from 'react-icons/fi';
import { GiHamburgerMenu } from 'react-icons/gi';

function HomeHeader({pricingRef}) {
  const {userDetails, notificationCount, makeApiCallFunc} = useContext(Context);
  const [showDropDown, setShowDropDown] = useState(false);  
  const dropdownRef = useRef(null);
  const dropdownbtnRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false)
  const navigate = useNavigate();

  const [mycasesLink, setMycasesLink] = useState('/attorney/casesFeed/availableCases');
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !dropdownbtnRef.current.contains(event.target))
        
      {
        setShowDropDown(false);
      }
    };if (showDropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropDown]);
   useEffect(() => 
    {
        if(userDetails?.role === CLIENT)
        {
            setMycasesLink('/client/cases');
        }
        else if(userDetails?.role === PROFESSIONAL)
        {
          const verified = userDetails?.verified;
          if(!verified)
          {
              if(!userDetails.isUserAssistant)
              {
                  makeApiCallFunc(
                  isUserVerifiedApi,
                  {verified: userDetails?.verified},
                  ({data}) => {
                      console.log(data);
                      if(data.verified === 0) // only unverified status
                      {
                        console.log("unverified")

                          setMycasesLink("/attorney/profileCompletion");
                        
                      }
                      else if(data.verified === 2 || data.verified === 5) // only pending verification status and denied approval
                      {
                        setMycasesLink("/attorney/profile");
                      }
                  }, 
                  (data) => {
                      console.log(data)
  
                  }
                  )
              }
              else if(userDetails.isUserAssistant && !userDetails?.profilePic)
              {
                  setMycasesLink("/attorney/profileCompletion");
              }
          } 
        }
          
                
        },[userDetails])

  return (
    <>
    {/* Overlay */}
      <div
        onClick={() => setOpenMenu(false)}
        className={`lg:hidden fixed inset-0 bg-black/40 z-40 transition-opacity duration-300
          ${openMenu ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      />

      {/* Side panel */}
      <aside
        className={`fixed lg:hidden top-0 left-0 z-50 h-full w-[320px] bg-gray-100
          transform transition-transform duration-300 ease-in-out
          ${openMenu ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="p-5 space-y-4">
          {/* Close Button */}
          <button
            onClick={() => setOpenMenu(false)}
            className="text-md text-gray-800 flex items-center justify-end w-full"
          >
            ✕ 
          </button>

          {/* Menu Items */}
          <nav className="flex flex-col gap-4">
            {
                  userDetails?.email ?
                  <>
                  <Link to= {
                    userDetails?.role === ADMIN ? 'admin/notification': (userDetails?.role === CLIENT ? 'client/notification' : '/attorney/notification')
                  }>
                  <div className='text-sm'>
                    My Notifications <span className='ml-2'>{notificationCount}</span>
                  </div>
                  </Link>
                  <div className='text-sky-600 text-sm '>
                    {userDetails?.role === ADMIN ?
                    <Link to='/admin/approve'>
                    <div>
                      Awaiting Approvals
                    </div>
                    </Link>
                    :
                    <Link to={
                      mycasesLink}>
                    <div>
                      My Dashboard
                    </div>
                    </Link>
                    }
                    </div>
                  </>
                    :
                  <>
                  </>
                }
            <Link to='/howItWorks/2'>
              <div
                className="text-sm font-medium truncate"
              >
                Flow for Clients and Attorneys
              </div>
            </Link>
            <Link to='/howItWorks/3'>
              <div
                className="text-sm font-medium truncate "
              >
                Flow for Assistants and Attorneys
              </div>
            </Link>
            {
              userDetails?.email ?
              <></>
              :
              <div onClick={()=>{
                setOpenMenu(false);
                pricingRef.current.scrollIntoView({behavior: 'smooth'}) }}
                  className='text-sm  cursor-pointer'>
                Pricing
              </div>
            }
          </nav>
        </div>
      </aside>


    <div className='hidden w-full lg:flex lg:flex-row flex-col justify-between text-gray-800 font-bold border-b-1 border border-t-0 text-[14px]  items-center  '>
        <div className='w-full flex items-center justify-between pt-1'>
            <div className='flex items-center '>
                <Link to='/'>
               <div className='flex cursor-pointer item-center  p-4  '>
                <Logo/>
               </div>
                </Link>
               <div className='flex ml-4 justify-evenly text-gray-600  p-4 flex-nowrap items-center '>
                {
                  
                    userDetails?.email ?
                    <>
                    <div className='text-sky-600 '>
                      {userDetails?.role === ADMIN ?
                      <Link to='/admin/approve'>
                      <div>
                        Awaiting Approvals
                      </div>
                      </Link>
                      :
                      <Link to={
                       mycasesLink}>
                      <div>
                        My Dashboard
                      </div>
                      </Link>
                      }
                      </div>
                    </>
                    :
                  <>
                  <div className='hidden lg:flex text-gray-600'>
                    <Link to='/signup/1'>
                        <div className='cursor-pointer  text-blue-800 '>
                        Find a Personal Injury Attorney
                        </div>
                    </Link>
                    <Link to='/signup/2'>
                    <div className='ml-6  cursor-pointer  text-blue-800'>
                    Find a Personal Injury Case
                    </div>
                    </Link>
                  </div>
                  </>
                }
                
                <div className='ml-6  relative' 
               
                >
                 <div
                    className={'cursor-pointer whitespace-nowrap text-gray-800' + (showDropDown ? ' text-blue-800' : '')}
                    onClick={() => setShowDropDown(!showDropDown)}
                    ref={dropdownbtnRef}
                  >
                  How it works
                  </div>
                  {
                  showDropDown &&
                  <>
                  <div className="absolute border-[10px] border-t-0  z-10 left-10 border-r-transparent border-l-transparent border-b-white h-0 w-0 -bottom-2"></div>
                  <div  ref={dropdownRef} className='bg-white absolute flex flex-col w-max text-center  text-sm border  inset-x-0 mx-auto  shadow-md  mt-2'>
                    <Link to='/howItWorks/2'>
                    <div className=' p-2 items-center  flex  cursor-pointer hover:text-gray-600 hover:bg-gray-100 hover:text-blue-800 bg-white-100 border-gray-200  border-r-1 border-t-0 border-l-0 border-b-0'>
                    Flow for Clients and Personal Injury Attorneys
                    </div>
                    </Link>
                    <Link to='/howItWorks/3' className=''>
                    <div className=' p-2   items-center   flex hover:bg-gray-100 hover:text-gray-600 bg-white-100 cursor-pointer hover:text-blue-800  '>
                    Flow for Assistants and Personal Injury Attorneys
                    </div>
                    </Link>
                  </div>
                  </>
                }
                  
                  </div>
                <div onClick={()=>{pricingRef.current.scrollIntoView({behavior: 'smooth'}) }}
                className='ml-6 text-gray-800 cursor-pointer'>
                      Pricing
                </div>
                
           </div>
            </div>
            <div className='flex items-center'>
            {
              userDetails?.email ?
              <>
              
              <Link to= {
                userDetails?.role === ADMIN ? 'admin/notification': (userDetails?.role === CLIENT ? 'client/notification' : '/attorney/notification')
              }>
              <div className='mr-4 ml-4'>
              <NotificationIcon count={notificationCount}/>
              </div>
              </Link>
              <HomeMiniAvatar/>
              </>
              :
              <>
               <Link to='/signin'>
                <div className='mr-4 hover:border-gray-200 hover:bg-gray-100 px-4 rounded border border-white p-2 cursor-pointer'>
                  Log in
                </div>
                </Link>
                <Link to='/signup'>
                <div className='mr-4 bg-blue-800 hover:text-blue-800 hover:bg-white border hover:border-blue-800 text-white p-2 px-4 rounded cursor-pointer'>
                  Sign up
                </div>
                </Link>
              </>
  }
            </div>
        </div>
        {
          userDetails?.email ?
          <></>
          :
           <div className='flex justify-between text-xs p-1 lg:hidden border-t text-gray-600'>
                    <Link to='/signup/1'>
                        <div className='cursor-pointer border-r py-4 pr-2 text-blue-800 '>
                        Find A Personal Injury Attorney
                        </div>
                    </Link>
                    <Link to='/signup/2'>
                    <div className='ml-6  cursor-pointer py-4  text-blue-800'>
                    Find A Personal Injury Case
                    </div>
                    </Link>
                  </div>
        }
    </div>
    <div className='lg:hidden w-full flex lg:flex-row flex-col justify-between text-gray-800 font-bold border-b-1 border border-t-0 text-[14px]  items-center  '>
        <div className='w-full flex items-center h-[50px] justify-between px-2'>
            <div className='flex justify-start'>
              <GiHamburgerMenu size={15} className='cursor-pointer'
              onClick={() => setOpenMenu(true)}
              />
            </div>
            <div className='flex items-center '>
                <Link to='/'>
               <div className='flex cursor-pointer item-center   '>
                <LogoMobile/>
                </div>
                </Link>
            </div>
            <div className='flex items-center'>
            {
              userDetails?.email ?
              <div className='gap-2 flex'>
                <Link to = "attorney/notification">
              <NotificationIcon  count={notificationCount}/>
              </Link>
              <HomeMiniAvatar/>
              </div>
              :
              <>
               <Link to='/signin'>
                <div className='hover:border-gray-200 hover:bg-gray-100  rounded border border-white text-xs cursor-pointer'>
                  Sign in
                </div>
                </Link>
                {/* <Link to='/signup'>
                <div className='bg-blue-800 hover:text-blue-800 hover:bg-white border hover:border-blue-800 text-white  rounded cursor-pointer'>
                  Sign up
                </div>
                </Link> */}
              </>
  }
            </div>
        </div>
        {
          userDetails?.email ?
          <></>
          :
           <div className='flex justify-between text-xs p-1 lg:hidden border-t text-gray-600'>
                    <Link to='/signup/1'>
                        <div className='cursor-pointer border-r py-4 pr-2 text-blue-800 '>
                        Find A Personal Injury Attorney
                        </div>
                    </Link>
                    <Link to='/signup/2'>
                    <div className='ml-6  cursor-pointer py-4  text-blue-800'>
                    Find A Personal Injury Case
                    </div>
                    </Link>
                  </div>
        }
    </div>
    </>
  )
}

export default HomeHeader
